import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Links to a landing-page section: a plain hash on the landing page, a routed `/#id` elsewhere.
const SectionLink = ({ id, children, ...rest }) => {
  const { pathname } = useLocation();
  if (pathname === '/') {
    return <a href={`#${id}`} {...rest}>{children}</a>;
  }
  return <Link to={`/#${id}`} {...rest}>{children}</Link>;
};

export default SectionLink;
